module.exports = __webpack_public_path__ + "254ab1b03164590562c229f6af666f14.png";